import { put, takeEvery } from 'redux-saga/effects';
import makeRequestSaga from 'store/common';
import { getWimsStatus } from 'api/statistics';

import { SagaPayload } from 'types';
import { GetStatisticQueryParamsType } from '../types';
import { requestWimsStatusInfo, getWimsStatusSuccess, getWimsStatusError, setIsLoading } from './slice';

export function* wimsStatusInfoRequestSaga({ payload }: SagaPayload<GetStatisticQueryParamsType>) {
  yield put(setIsLoading(true));
  yield makeRequestSaga(getWimsStatusSuccess, getWimsStatusError, getWimsStatus);
}

export function* wimsStatusInfoRequestWatchSaga() {
  yield takeEvery(requestWimsStatusInfo, wimsStatusInfoRequestSaga);
}
